import React from 'react'

import { Link, useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'
import { routes } from 'routes'
import qs from 'qs'
import moment from 'moment'

import {
  Box,
  Button,
  Divider,
  Paper,
  Typography,
  Chip,
} from '@material-ui/core'

import {
  BookmarkBorderOutlined,
  ShortTextOutlined,
  AttachMoneyOutlined,
  ErrorOutlineOutlined,
} from '@material-ui/icons'

import { Container, ContentHeader, DotStatus } from 'components'
import { Permitted } from 'components/Permissions'
import { ContainerSummary, ItemSummary } from 'components/Summary'
import { LogButton } from 'components/Logs'
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from 'components/Table'
import PlansDisable from './components/PlansDisable'
import * as service from 'service'
import contractStatusColor from 'helpers/contracts/statusColor'
import helpers from 'helpers'
import currency from 'helpers/currency'
import useFetch from 'hooks/useFetch'

const PlansShow = ({ match }) => {
  const planId = match.params.planId

  const { response: responsePlan, isLoading, refresh } = useFetch(
    service.recurrence.plans.get,
    {
      planId,
    },
  )

  const handleStatusChange = () => {
    refresh()
  }

  return (
    <Container>
      <ContentHeader title="Plano" subtitle="Detalhes">
        <Box display="flex">
          <LogButton
            to={reverse(routes.plans.logs, {
              planId,
            })}
          />
          <Permitted tag="update_plan">
            <Box ml={2}>
              <Button
                variant="contained"
                color="primary"
                component={Link}
                to={reverse(routes.plans.edit, { planId })}
              >
                Editar
              </Button>
            </Box>
          </Permitted>
        </Box>
      </ContentHeader>
      <Box mb={4}>
        <ContainerSummary isLoading={isLoading}>
          <ItemSummary
            title="Código"
            value={responsePlan && responsePlan.data.plan.code}
            icon={<BookmarkBorderOutlined color="disabled" />}
          />
          <ItemSummary
            title="Nome"
            value={responsePlan && responsePlan.data.plan.name}
            icon={<ShortTextOutlined color="disabled" />}
          />
          <ItemSummary
            title="Valor"
            value={responsePlan && currency(responsePlan.data.plan.price)}
            icon={<AttachMoneyOutlined color="disabled" />}
          />
          <ItemSummary
            title="Status"
            value={
              <Chip
                label={
                  responsePlan && responsePlan.data.plan.active
                    ? 'Ativo'
                    : 'Inativo'
                }
                size="small"
                style={{
                  backgroundColor: contractStatusColor(
                    responsePlan && responsePlan.data.plan.active
                      ? 'active'
                      : 'inactive',
                  ),
                  color: 'white',
                }}
              />
            }
            icon={<ErrorOutlineOutlined color="disabled" />}
          />
        </ContainerSummary>
      </Box>

      <Box mb={4}>
        <Paper>
          <Box p={2}>
            <Typography variant="h4">Descrição</Typography>
          </Box>
          <Divider />
          <Box p={2} display="flex" justifyContent="space-evenly">
            <Typography>
              {responsePlan && responsePlan.data.plan.description}
            </Typography>
          </Box>
        </Paper>
      </Box>

      {!isLoading && (
        <Box mb={4}>
          <ContractList planCode={responsePlan.data.plan.code}></ContractList>
        </Box>
      )}

      <Permitted tag="destroy_plan">
        {!isLoading && (
          <Box mb={4}>
            <PlansDisable
              planId={responsePlan.data.plan.id}
              active={responsePlan.data.plan.active}
              onStatusChange={handleStatusChange}
            />
          </Box>
        )}
      </Permitted>
    </Container>
  )
}

const ContractList = ({ planCode }) => {
  const history = useHistory()

  const { response: responseContracts, isLoading } = useFetch(
    service.recurrence.contracts.get,
    { 'contract[contract_plans][plan_code]': planCode, perPage: 5 },
  )

  const handleClickShow = contractId => {
    const url = reverse(routes.contracts.show, { contractId })
    history.push(url)
  }

  const handleClickIndex = () => {
    history.push({
      pathname: '/contracts',
      search: qs.stringify({ contractPlans: { planCode: planCode } }),
    })
  }

  return (
    <Paper>
      <Box
        p={2}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="h4">Últimas assinaturas</Typography>
        <Permitted tag="update_plan">
          <Button variant="outlined" color="primary" onClick={handleClickIndex}>
            Detalhar
          </Button>
        </Permitted>
      </Box>

      <Divider />

      <Table
        emptyMessage="Não há assinaturas desse plano"
        isLoading={isLoading}
        noWrap
      >
        <TableHead>
          <TableRow>
            <TableCell>Assinatura</TableCell>
            <TableCell>Data de geração</TableCell>
            <TableCell>Nome</TableCell>
            <TableCell align="center">Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {responseContracts &&
            responseContracts.data.contracts.map(contract => (
              <TableRow
                key={contract.id}
                hover
                onClick={() => handleClickShow(contract.id)}
              >
                <TableCell>{contract.id}</TableCell>
                <TableCell>
                  {moment(contract.createdAt).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell>{contract.customer.name}</TableCell>
                <TableCell align="center">
                  <DotStatus
                    statusName={helpers.contracts.status(contract.status)}
                    size="small"
                    statusTag={contract.status}
                  />
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </Paper>
  )
}

export default PlansShow
